import React, { useState } from 'react';
import { CarFront, ChevronLeft, ChevronRight, MessageCircle } from 'lucide-react';
import type { Vehicle } from '../types/vehicle';
const WHATSAPP = 'https://wa.me/5491127063704';
function VehicleCarousel({
  fotos,
  alt
}: {
  fotos: string[];
  alt: string;
}) {
  const [index, setIndex] = useState(0);
  const total = fotos.length;
  if (total === 0) {
    return <div className="vehicle-photo-frame flex items-center justify-center" data-id="element-513" data-mp="qhz9sfi8ie6m">
        <CarFront className="w-14 h-14 text-brand-white/20" data-id="element-514" data-mp="qfuwx82cy4u7" />
      </div>;
  }
  const go = (next: number) => setIndex((next + total) % total);
  return <div data-id="element-515" data-mp="zbcd8bdxcy6y">
      <div className="vehicle-photo-frame group" data-id="element-516" data-mp="zc3v6jelmxer">
        <div className="flex h-full transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)]" style={{
        transform: `translateX(-${index * 100}%)`
      }} data-id="element-517" data-mp="uk2nzbwafwvl">
          {fotos.map((foto, i) => <img key={i} src={foto} alt={`${alt} — foto ${i + 1} de ${total}`} loading="lazy" data-id="element-518" data-mp="2rliwsbdyldm" data-mpi={i} />)}
        </div>

        {total > 1 && <>
            <button type="button" onClick={() => go(index - 1)} aria-label="Foto anterior" className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/60 text-brand-white flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200 hover:bg-brand-gold hover:text-brand-black" data-id="element-519" data-mp="30801zimljps">
              <ChevronLeft className="w-5 h-5" data-id="element-520" data-mp="3l7nsye1170b6" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Foto siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/60 text-brand-white flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200 hover:bg-brand-gold hover:text-brand-black" data-id="element-521" data-mp="3l6cpkfbhzukl">
              <ChevronRight className="w-5 h-5" data-id="element-522" data-mp="2wkjy4tveyosq" />
            </button>
          </>}
      </div>

      <div className="h-[30px] flex items-center justify-center gap-1.5" data-id="element-523" data-mp="3akchu58iw4r7">
        {total > 1 && fotos.map((foto, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Ver foto ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-all duration-200 ${i === index ? 'w-5 bg-brand-gold' : 'w-1.5 bg-brand-white/25'}`} data-id="element-524" data-mp="36jsnf9fc3f8r" data-mpi={i} />)}
      </div>
    </div>;
}
export function VehicleCard({
  vehicle
}: {
  vehicle: Vehicle;
}) {
  const vendido = vehicle.estado === 'Vendido';
  const nombre = `${vehicle.marca} ${vehicle.modelo}`;
  const message = `Hola! Me interesa el ${nombre} ${vehicle.anio}. ¿Está disponible?`;
  return <article className="bg-[#1A1A1A] border-t-[3px] border-t-brand-gold rounded-b-lg overflow-hidden flex flex-col h-full" data-id="element-525" data-mp="1kzdttyvqenxe">
      <VehicleCarousel fotos={vehicle.fotos} alt={nombre} data-id="element-526" data-mp="1pr5mqg2d15qp" />

      <div className="px-5 pb-5 pt-4 flex flex-col flex-grow" data-id="element-527" data-mp="1b1pv6xv08w9y">
        <span className={`self-start text-[11px] font-bold px-2.5 py-1 rounded mb-3 ${vendido ? 'bg-white/15 text-brand-white/70' : 'bg-brand-gold text-brand-black'}`} data-id="element-528" data-mp="1azd8k7eaxxqk">
          {vendido ? 'VENDIDO' : 'DISPONIBLE'}
        </span>

        <h3 className="text-brand-white font-bold text-base leading-snug" data-id="element-529" data-mp="28n5f3rz92bat">
          {nombre}
        </h3>
        <p className="text-brand-white/50 text-[13px] mt-1" data-id="element-530" data-mp="1tubnx9am86qb">
          {[vehicle.anio, vehicle.km ? `${Number(vehicle.km).toLocaleString('es-AR')} km` : null, vehicle.combustible].filter(Boolean).join(' · ')}
        </p>

        {vehicle.precioArs && <p className="font-heading text-2xl text-brand-gold leading-none mt-3" data-id="element-531" data-mp="13jjl78ulpoir">
            ${Number(vehicle.precioArs).toLocaleString('es-AR')}
          </p>}

        <div className="mt-auto pt-5" data-id="element-532" data-mp="tt87wvp122z7">
          <a href={`${WHATSAPP}?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 bg-brand-gold text-brand-black font-bold text-sm rounded hover:bg-brand-white transition-colors" data-id="element-533" data-mp="tu9vu0r56jyc">
            <MessageCircle className="w-4 h-4" data-id="element-534" data-mp="1hgq4r5n5fr91" />
            Consultar por WhatsApp
          </a>
        </div>
      </div>
    </article>;
}